import React from 'react';

import EventInfo from '.';

const eventInfoProps = {
  attachments: [
    { title: 'Agenda', url: 'https://test.com' },
    { title: 'Map', url: 'https://another_test.com' },
  ],
  headerImageUrl: 'spec/fixtures/play-button.png',
  offerCode: 'offer-code',
};

describe('<EventInfo />', () => {
  it('renders', () => {
    const { getByRole } = global.render(<EventInfo {...eventInfoProps} />);

    expect(getByRole('presentation')).toHaveAttribute('src', eventInfoProps.headerImageUrl);
    eventInfoProps.attachments.forEach((attachment) => {
      expect(getByRole('button', { name: attachment.title })).toHaveAttribute(
        'href',
        attachment.url
      );
    });
    expect(getByRole('button', { name: 'Subscribe to the Information' })).toHaveAttribute(
      'href',
      `/subscribe?offer=${eventInfoProps.offerCode}`
    );
  });

  it('handles no offer code', () => {
    const { getByRole } = global.render(<EventInfo {...eventInfoProps} offerCode={null} />);

    expect(getByRole('button', { name: 'Subscribe to the Information' })).toHaveAttribute(
      'href',
      `/subscribe`
    );
  });
});
